import { render } from "./UiTree.vue?vue&type=template&id=1f08b600&ts=true"
import script from "./UiTree.vue?vue&type=script&lang=ts"
export * from "./UiTree.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__